import React from 'react';

import {CONFIGURATION_SEQUENCE} from '@constants/resources';
import {SECURITY_PRIVILEGES_CREATE_READ} from '@constants/variables';
import Link from '@appComponents/Link';
import {ButtonAdd} from '@appComponents/ButtonCollection';
import {Authorization} from '@appComponents/Authorization';

export const SequenceConfigButtons = () => {
    const authorizationObject = {
        [CONFIGURATION_SEQUENCE]: SECURITY_PRIVILEGES_CREATE_READ,
    };

    return (
        <div className='configuration_sequences__indexButtons content__buttons'>
            <Authorization authorization={authorizationObject}>
                <Link name='sequenceConfigs.add'>
                    <ButtonAdd>{'Add new sequence config'}</ButtonAdd>
                </Link>
            </Authorization>
        </div>
    );
};
